import * as React from 'react'
import './style.scss'
import Sphere from '../../Atoms/Sphere';

const NotFound = (props) => {
  return (
  <div className="Body">
    {/* <div className="MainFrame" style={{
      backgroundImage: `url("${MainFrame}")`,
    }}>
    </div> */}
    <div className="Content-404">   
      <div className="b-404">
        4
        <Sphere color="red_2" />
        4
      </div>
      <p className="Text">Страница, которую вы ищите, не существует</p>
      <a className="Button" href="/justy">Вернуться на главную</a>
    </div>
  </div>
)};
  
  export default NotFound;
  